import { useState } from 'react';
import { useBootstrapSelector } from '../../../redux/selectorHooks';
import VerticalField from '../VerticalField';
import FieldError from '../FieldError';
import FieldLabel from '../FieldLabel';
import EmailInput from './EmailInput';

interface IProps {
  label: string;
  emails: string[];
  onChange: (email: string, emailError?: string) => void;
  onPaste: (emails: string[]) => void;
  error: string | null;
  disabled?: boolean;
}

const EmailInputField = ({
  label,
  emails,
  onChange,
  onPaste,
  error,
  disabled,
}: IProps) => {
  const [focused, setFocused] = useState(false);
  const scheduleEmailDomains = useBootstrapSelector('scheduleEmailDomains');

  const handleFocus = () => {
    setFocused(true);
  };
  const handleBlur = (email: string, emailError?: string) => {
    setFocused(false);
    onChange(email, emailError);
  };

  return (
    <VerticalField noMargin={true}>
      <FieldLabel icon="envelope">{label}</FieldLabel>
      <EmailInput
        onBlur={handleBlur}
        onFocus={handleFocus}
        onPaste={onPaste}
        hasError={!!error}
        placeholder={'Type email and press Enter'}
        emails={emails}
        emailDomains={scheduleEmailDomains}
        disabled={disabled}
      />
      {!focused && error && <FieldError type="custom" customError={error} />}
    </VerticalField>
  );
};

export default EmailInputField;
